const initMenu = () => {
    const menu = document.querySelector('.menu');
    const submenu = document.querySelectorAll('.menu-sitemap__sublist');
    const toggleButton = document.querySelector('.menu-toggle__button');
    const menuPopover = document.querySelectorAll('[data-menu-popover]');

    const focusableElements = menu.querySelectorAll('a, button, details');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    /**
     * Handle hamburger menu.
     */

    const closeMenu = () => {
        menu.dataset.menuDialog = 'close';
        toggleButton.setAttribute('aria-expanded', false);
        toggleButton.focus();
        document.body.classList.remove('no-scroll');
    };

    const openMenu = () => {
        menu.dataset.menuDialog = 'open';
        toggleButton.setAttribute('aria-expanded', true);
        document.body.classList.add('no-scroll');
    };

    const toggleMenu = () => {
        menu.dataset.menuDialog === 'open' ? closeMenu() : openMenu();
    };

    const trapFocus = (event) => {
        if (menu.dataset.menuDialog !== 'open') {
            return;
        }

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    event.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        }
    };

    const handleKeydown = (event) => {
        (event.key === 'Escape' || event.keyCode === 27) && closeMenu();
    };

    toggleButton.addEventListener('click', toggleMenu);
    menu.addEventListener('keydown', trapFocus);
    menu.addEventListener('keydown', handleKeydown);

    /**
     * Handle submenu.
     * Close all submenus except the one clicked.
     */

    const closeOtherSubmenus = (el) => {
        submenu.forEach((item) => item !== el && item.removeAttribute('open'));
    };

    submenu.forEach((targetItem) => {
        targetItem.addEventListener('click', () => closeOtherSubmenus(targetItem));
    });

    /**
     * Handle Menu Popover.
     * Close when click outside of the submenu.
     */

    const closemenuPopover = (el) => {
        el.removeAttribute('open');
    };

    document.addEventListener('click', (event) => {
        menuPopover.forEach((targetItem) => {
            const isClickInside = targetItem.contains(event.target);
            !isClickInside && closemenuPopover(targetItem);
        });
    });
};

initMenu();
